import styled from 'styled-components';
import { colors, opacities } from '../../../defaultTheme';
import { Inset } from '../../spacing';
export const Overlay = styled.div `
  ${({ isOpen }) => isOpen &&
    `
    :after {
      content: "";
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      background-color: ${opacities.rgbaHalfOpacity};
    }
  `}
`;
export const BottomSheetWrapper = styled.div `
  position: fixed;
  bottom: 0;
  height: fit-content;
  overflow: auto;
  z-index: 2;
  left: 50%;
  background-color: ${colors.white};
  opacity: 0;
  max-height: 85vh;
  border-radius: 10px;
  box-shadow: 0 4px 5px 0 ${opacities.rgbaLight10},
    0 3px 14px 3px ${opacities.rgbaLight08},
    0 8px 10px 1px ${opacities.rgbaLight04};
  display: flex;
  flex-direction: column;
  transition-property: opacity, transform;
  transition-duration: ${(props) => `${props.transitionDuration}ms`},
    ${(props) => `${props.transitionDuration}ms`}, 0s;
  transition-timing-function: linear, ease-in-out;
  width: 370px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  ::-webkit-scrollbar {
    display: none;
  }
`;
export const HeaderWrapper = styled.div `
  position: sticky;
  z-index: 2;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
`;
export const BottomSheetGrabber = styled.div `
  width: 40px;
  height: 5px;
  background-color: #656565;
  border-radius: 0.3rem;

  &:focus {
    outline: 2px solid ${({ theme }) => theme.focus};
    outline-offset: 2px;
  }
`;
export const BottomSheetContent = styled.div `
  width: 100%;
`;
export const StyledFooter = styled(Inset) `
  display: flex;
  box-sizing: border-box;
  justify-content: flex-end;
  width: 100%;
`;
